import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgFaceIdLockFilled = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.149 20.25H6.892a3.145 3.145 0 0 1-3.143-3.14v-1.569a.75.75 0 0 0-1.5 0v1.57a4.647 4.647 0 0 0 4.643 4.64h1.257a.75.75 0 0 0 0-1.5M21.001 14.792a.75.75 0 0 0-.75.75v1.568c0 1.733-1.41 3.14-3.143 3.14h-1.289a.75.75 0 0 0 0 1.5h1.289a4.647 4.647 0 0 0 4.643-4.64v-1.569a.75.75 0 0 0-.75-.75M2.999 9.22a.75.75 0 0 0 .75-.75V6.9a3.15 3.15 0 0 1 3.143-3.15h1.289a.75.75 0 0 0 0-1.5H6.892A4.65 4.65 0 0 0 2.249 6.9v1.57c0 .415.336.75.75.75M17.108 2.25H15.85a.75.75 0 0 0 0 1.5h1.257A3.15 3.15 0 0 1 20.25 6.9v1.571a.75.75 0 0 0 1.5 0v-1.57a4.65 4.65 0 0 0-4.643-4.65M11.98 8.24h.011c.776 0 1.412.627 1.422 1.392v.509h-2.825v-.507A1.414 1.414 0 0 1 11.98 8.24m4.378 6.48v-2.04a2.54 2.54 0 0 0-1.446-2.28v-.778a2.927 2.927 0 0 0-2.927-2.881h-.025a2.91 2.91 0 0 0-2.872 2.88v.78a2.54 2.54 0 0 0-1.446 2.28v2.04a2.547 2.547 0 0 0 2.548 2.54h3.622a2.546 2.546 0 0 0 2.546-2.54"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgFaceIdLockFilled);
export default ForwardRef;
